import { render, staticRenderFns } from "./GGanttBar.vue?vue&type=template&id=120c5f8a&scoped=true"
import script from "./GGanttBar.vue?vue&type=script&lang=js"
export * from "./GGanttBar.vue?vue&type=script&lang=js"
import style0 from "./GGanttBar.vue?vue&type=style&index=0&id=120c5f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c5f8a",
  null
  
)

export default component.exports